import * as React from 'react';
import { Row } from './layout/Row';
import { SubjectDTO } from '../../../api/core';
import { ReactNode } from 'react';
import { SubRow } from './layout/Subrow';
import { getNotation, getVocabularyOptions } from '../../../Vocabulary/util';
import { IntlShape, useIntl } from 'react-intl';
import { SelectItem } from 'primereact/selectitem';

interface Props {
  subjects: SubjectDTO[];
}

export const SubjectsRow: React.FC<Props> = (props: Props): ReactNode => {
  const intl: IntlShape = useIntl();
  const groupedSubjects: {[key: string]: SubjectDTO[]} = Object.groupBy(props.subjects, ({type}: SubjectDTO): string => type);
  const subjectGroups: SelectItem[] = getVocabularyOptions(intl.locale, 'subject_type_list', '*');
  return <Row title={intl.formatMessage({id: 'work.attr.subjects.label'})}>
    {subjectGroups.filter((group: SelectItem): boolean => group.value as string in groupedSubjects).map((group: SelectItem): ReactNode => (
      <SubRow>
        <div>{group.label}</div>
        <div>{groupedSubjects[group.value as string].sort((a: SubjectDTO, b: SubjectDTO): -1|1 => a.subjectId > b.subjectId ? 1 : -1).map((subject: SubjectDTO): ReactNode => (
          <div key={subject.subjectId}>{getNotation(`${group.value as string}_subject_list`, subject.subjectId, intl.locale, '*')} ({subject.subjectId})</div>
        ))}</div>
      </SubRow>
    ))}
  </Row>;
};
